<template>
    <div>
        <div class="card-header">
            <div class="card-header">
                <div class="d-flex">
                    <div class="flex-fill">
                        <StatementNotificationSearch></StatementNotificationSearch>
                    </div>

                    <div class="float-end">
                        <StatementNotificationPagination></StatementNotificationPagination>
                    </div>

                </div>

            </div>

            <div class="card-body">
                <StatementNotificationTable></StatementNotificationTable>
            </div>
        </div>
    </div>
</template>
<script>
import StatementNotificationSearch from "@/components/FamilyStatements/FamilyStatementMenu/FamilyStatementNotificationList/Family-statement-notification-search.vue";
import StatementNotificationTable from "@/components/FamilyStatements/FamilyStatementMenu/FamilyStatementNotificationList/Family-statement-notification-table.vue";
import StatementNotificationPagination from "@/components/FamilyStatements/FamilyStatementMenu/FamilyStatementNotificationList/Family-statement-notification-pagination.vue";

export default {
    name: 'StatementNotificationList',

    components:{
        StatementNotificationTable,
        StatementNotificationPagination,
        StatementNotificationSearch
    }
}
</script>
<style></style>
